'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ToneIcon } from '../tone-icon/tone-icon';
import { InlineFeedbackRootContext } from './context/inline-feedback-root.context';
import { inlineFeedbackIconRecipe } from './styles/inline-feedback-icon.styles';
import type { InlineFeedbackIconPropsInterface } from './types/inline-feedback-icon.types';

/**
 * @since 10.0.0
 */

export const InlineFeedbackIcon = forwardRef<SVGSVGElement, InlineFeedbackIconPropsInterface>(
  (props: InlineFeedbackIconPropsInterface, forwardedRef) => {
    const inlineFeedbackRootContext = useContext(InlineFeedbackRootContext);
    const { tone = inlineFeedbackRootContext.tone || 'info', css: cssProp, ...rest } = props;

    return (
      <ToneIcon
        ref={forwardedRef}
        data-c11n-component="InlineFeedback.Icon"
        data-c11n-version={__C11N_VERSION__}
        size="md"
        tone={tone}
        css={css.raw(inlineFeedbackIconRecipe.raw({ tone }), cssProp)}
        {...rest}
        className={cx('c11n_inline-feedback__icon', rest.className)}
      />
    );
  },
);

InlineFeedbackIcon.displayName = 'InlineFeedback.Icon';
